const MERCHANT_USER = {
    DETAILS: {
        url: '/contractsAccesses/:contractAccessId/users',
        queryKey: 'getMerchantUsers'
    },
    MERCHANT_PROFILE: {
        url: '/merchant/userProfiles/:organizationId',
        queryKey: 'getMerchantProfiles'
    },
    RESET_PASSWORD_USERS: {
        url: '/users/resetPassword/token'
    }
};

export default MERCHANT_USER;